/**
 * URL til et forhandler-logo.
 *
 * De fleste logoer ligger som en relativ sti i vores eget billed-endpoint, men
 * forhandlere der kommer fra Adtraction har en ABSOLUT url
 * (https://adtraction.com/image.htm?imgId=...). Blev den sat sammen med
 * præfikset, opstod "/retailer-imageshttps://adtraction.com/..." — en 404 og et
 * manglende logo. Ramte CS MEGASTORE og Estore.
 */
export function retailerLogoUrl(logo) {
    if (!logo) {
        return null;
    }

    // Både http og https, og protokol-relative //host/sti.
    if (/^(https?:)?\/\//i.test(logo)) {
        return logo;
    }

    return `/retailer-images${logo.startsWith('/') ? '' : '/'}${logo}`;
}

/**
 * Er billedet for lille til at være et logo?
 *
 * 12 forhandlere har en favicon.ico i logo-feltet, og BatteryStore & More er
 * en 16x16 med 16 farver. Den loader fint, så @error udløses aldrig — den
 * bliver bare strakt op i en 200px-boks og ligner et ødelagt billede.
 *
 * Grænsen er sat lavt med vilje. Et rigtigt logo er sjældent under 40 px, og
 * en favicon er aldrig over 64.
 */
export function forLilleTilLogo(event) {
    const img = event?.target;

    if (!img) {
        return false;
    }

    return img.naturalWidth > 0 && img.naturalWidth < 40;
}
